import { Collapse } from 'antd';
import { HelpCenterCollapseButton } from '../button/help-center-collapse-button';

export const HelpCenterCollapsiblePanel = ({ items, panelStyle = {}, defaultActiveKey }) => {
  return (
    <Collapse
      ghost
      items={items}
      defaultActiveKey={defaultActiveKey}
      expandIcon={({ isActive }) => <HelpCenterCollapseButton isActive={isActive} />}
      expandIconPosition="end"
      style={panelStyle}
    />
  );
};
